import { render, staticRenderFns } from "./RewardPrizePool.vue?vue&type=template&id=003fbf75&"
import script from "./RewardPrizePool.vue?vue&type=script&lang=js&"
export * from "./RewardPrizePool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003fbf75')) {
      api.createRecord('003fbf75', component.options)
    } else {
      api.reload('003fbf75', component.options)
    }
    module.hot.accept("./RewardPrizePool.vue?vue&type=template&id=003fbf75&", function () {
      api.rerender('003fbf75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardPrizePool.vue"
export default component.exports